import React from 'react'
import { PatchCheckFill } from 'react-bootstrap-icons'

export default function ReachbirdApprovedBadge({ compact = false, title = 'Reachbird Approved: has completed at least one Reachbird collaboration' }) {
  if (compact) {
    return (
      <span title={title} className="inline-flex items-center text-rb-green">
        <PatchCheckFill className="text-sm" />
      </span>
    )
  }

  return (
    <span title={title} className="inline-flex items-center gap-1 rounded-2xl bg-rb-green px-3 h-6 text-xs font-semibold text-white whitespace-nowrap dark:text-rb-dark-mode">
      <PatchCheckFill className="text-xs" />
      Reachbird Approved
    </span>
  )
}
